/**
 * Resolve env during SSR / Node (Next.js "Collecting page data", OpenNext build)
 * when `window` is unavailable. CL deploy sets NEXT_PUBLIC_ENV_NAME (see deploy-cl.js).
 */
function getEnvNameFromNodeEnv(): 'dev' | 'staging' | 'prod' {
  const envName =
    typeof process !== 'undefined' && process.env?.NEXT_PUBLIC_ENV_NAME
      ? process.env.NEXT_PUBLIC_ENV_NAME.toLowerCase()
      : ''

  if (envName.includes('staging')) {
    return 'staging'
  }
  if (envName.includes('prod')) {
    return 'prod'
  }
  if (envName === 'local-build') {
    return 'dev'
  }
  if (
    typeof process !== 'undefined' &&
    process.env?.NODE_ENV === 'development'
  ) {
    return 'dev'
  }
  // Match browser fallback for unknown hosts: assume prod (custom domains, CI prod build)
  return 'prod'
}

export function getEnvName(): 'dev' | 'staging' | 'prod' {
  // infer env from url to ensure staging/prod build are same
  if (__REACT_NATIVE__) {
    if (__DEV__) return 'dev'
    else return 'prod'
  } else {
    // web — SSR / build has no window
    if (typeof window === 'undefined') {
      return getEnvNameFromNodeEnv()
    }

    const hostname = window.location.hostname

    if (hostname.endsWith('localhost') || hostname.endsWith('local')) {
      return 'dev'
    }

    if (
      hostname == 'custom.domain.disco-staging-3.com' ||
      hostname.endsWith('dsc.party') ||
      hostname.endsWith('disco-staging-2.com')
    ) {
      return 'staging'
    }

    // other temp stagings (might or might not be used widely)
    // if (hostname.endsWith('disco-staging-3.com')) return 'staging-3'
    // if (hostname.endsWith('disco-staging-4.com')) return 'staging-4'
    if (hostname.endsWith('disco.ac')) {
      return 'prod'
    }

    // assume prod custom domains by default
    return 'prod'
  }
}
export const __REACT_NATIVE__: boolean =
  typeof navigator !== 'undefined' && navigator?.product === 'ReactNative'
export const userTokenKey = 'userToken'
export const RTK_MIDDLEWARE_CONFIG = {
  immutableCheck: {
    warnAfter: 1000,
  },
  // fix and re-enable https://redux-toolkit.js.org/api/getDefaultMiddleware
  serializableCheck: false,
}
